// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export var AccountSummaryTablesEnum;
(function (AccountSummaryTablesEnum) {
    AccountSummaryTablesEnum[AccountSummaryTablesEnum["General"] = 0] = "General";
    AccountSummaryTablesEnum[AccountSummaryTablesEnum["Margin"] = 1] = "Margin";
    AccountSummaryTablesEnum[AccountSummaryTablesEnum["AccountActivity"] = 2] = "AccountActivity";
    AccountSummaryTablesEnum[AccountSummaryTablesEnum["TodaysResults"] = 3] = "TodaysResults";
})(AccountSummaryTablesEnum || (AccountSummaryTablesEnum = {}));
